import { Component, OnInit } from '@angular/core';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { ConfirmationService } from 'primeng/api';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { SyncProcessLogsService } from 'app/modules/vehicle-inventory/services/table-management/syncProcessLogs.service';

@Component({
    selector: 'app-sync-process-logs',
    templateUrl: './sync-process-logs.component.html',
    styleUrls: ['./sync-process-logs.component.css'],
    providers: [SyncProcessLogsService, ConfirmationService, UserTimePipe],
    standalone: false,
})
export class SyncProcessLogsComponent
    extends EntityListComponent<Rest.InvSyncProcessLogs>
    implements OnInit {

    showErrorDialog: boolean = false;
    selectedLog: Rest.InvSyncProcessLogs;

    constructor(
        syncProcessLogsService: SyncProcessLogsService,
        protected confirmationService: ConfirmationService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        authenticationService: AuthenticationService,
        protected loadingService: LoadingService,
        protected userTime: UserTimePipe,
        protected translateService: TranslateService,
    ) {
        super(
            syncProcessLogsService,
            confirmationService,
            notificationsService,
            i18n,
            authenticationService,
            loadingService,
            userTime,
        );
    }

    ngOnInit() {
        super.ngOnInit();
    }

    beforeLoad(): void {
        this.paginationRequest.sortBy = 'startDate';
        this.paginationRequest.sortAsc = false;
    }

    editDialog(entity: Rest.InvSyncProcessLogs) {
        if (!this.isSelectableColumn) {
            this.selectedLog = entity;
            this.showErrorDialog = true;
        }
        this.isSelectableColumn = false;
        this.isColumn = true;
    }
}